import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchSellerPOVendorPayments } from '../../../api/vendorPayment';
import { raiseToast } from '../toast/toast';
import { getSearchActiveStatus } from '../../../../utils';

const vpConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Vendor Payments Data', value: 'vendorPaymentsData' }
        ]
    },
    {
        srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    {
        srNO: 3,
        static: false,
        type: "SELECT",
        name: "branchId",
        label: "Branch",
    },
    {
        srNO: 4,
        static: true,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' }
        ]
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "vendorPaymentStatus",
        label: "VP Status",
        options: [
            { label: 'Requested', value: 12 },
            { label: 'Approved', value: 9 },
            { label: 'Rejected', value: 8 },
            { label: 'Payment Done', value: 10 },
            { label: 'Payment Rejected', value: 11 }
        ]
    },
    {
        srNO: 6,
        static: false,
        type: "SELECT",
        name: "attributeType",
        label: "Attribute Type",
        options: [
            { label: 'Expense', value: "expense" },
        ]
    },
    {
        srNO: 7,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPODocNo",
        label: "Seller PO No",
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "PINo",
        label: "PI No",
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentNo",
        label: "Vendor Payment No",
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentAmount",
        label: "Vendor Payment Amount",
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "product",
        label: "Product",
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "AUTO_COMPLETE",
        name: "kamName",
        label: "Kam Name",
        priority: 1
    },
    {
        srNO: 13,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerCompanyName",
        label: "Seller Company Name",
        priority: 3
    },
    {
        srNO: 14,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "AUTO_COMPLETE",
        name: "companyName",
        label: "Buyer Company Name",
        priority: 2
    },
    {
        srNO: 15,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "kamEmail",
        label: "Kam Email",
    },
    {
        srNO: 16,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "buyerEmail",
        label: "Buyer Email",
    },
    {
        srNO: 17,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentAmountGreaterThan",
        label: "VP Amount Greater Than",
    },
    {
        srNO: 18,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentAmountLessThan",
        label: "VP Amount Less Than",
    },
    {
        srNO: 19,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label: "Doc No",
    }
]

export const fetchSellerPOVendorPayments = createAsyncThunk('user/getSellerPOVendorPayments', async (params, { dispatch }) => {
    const response = await searchSellerPOVendorPayments(params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: response.data.error, detail: 'Invalid text', life: 3000}))
        throw Error()
    }
    return response
})

export const vendorPaymentSellerPOSlice = createSlice({
    name: "user/getSellerPOVendorPayments",
    initialState: {
        loading: false,
        sellerPOVendorPaymentsData: [],
        vendorPayments: [],
        companyBankAccounts: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "vendorPaymentsData",
            searchBy: "all",
            statusIds: [3, 13, 4],
            searchText: "",
            dateType: "createdAt",
        },
        searchOptions: [],
        isSearchVisible: true,
        isSearchActive: false,
        searchConfig: [...vpConfig],
        isSearchPinned: true,
        isSearchByLocked: false
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))

            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)

            state.isSearchActive = isSearchActive
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        setIsSearchPinned: (state, action) => {
            state.isSearchPinned = action.payload
        },
        setIsSearchByLocked: (state, action) => {
            state.isSearchByLocked = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchSellerPOVendorPayments.fulfilled, (state, action) => {
                state.loading = false 
                state.sellerPOVendorPaymentsData = action.payload.data.data
                state.vendorPayments = action.payload.data.vendorPayments
                state.companyBankAccounts = action.payload.data.companyBankAccounts
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                }
                if(action.payload.data.excessPagesFound || !action.payload.data.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.data.excessPagesFound
                    }else if(action.payload.data.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
                if(state.sellerPOVendorPaymentsData.length && !state.isSearchPinned){
                    state.isSearchVisible = false
                }
            }
        )
        .addCase(
            fetchSellerPOVendorPayments.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchSellerPOVendorPayments.rejected, (state, action) => {
                state.loading = false
                state.sellerPOVendorPaymentsData = []
                state.paginationParams.totalRecords = 0
            }
        )
    }
})


export const { updateSearchParams, updateSearchOptions, setIsSearchVisible, setSearchConfig, setIsSearchPinned, setIsSearchByLocked } = vendorPaymentSellerPOSlice.actions

export default vendorPaymentSellerPOSlice.reducer